import { makeActionCreator } from '../../../utilities'
import { SceneDescriptionConstants } from './sceneDescription.constants'

export const setSceneDescription = makeActionCreator(
  SceneDescriptionConstants.SET_SCENE_DESCRIPTION,
  'sceneDescription'
)
export const setNumPtsScene = makeActionCreator(SceneDescriptionConstants.SET_NUM_PTS_SCENE, 'numPtsScene')
export const setFirstOnScene = makeActionCreator(SceneDescriptionConstants.SET_FIRST_ON_SCENE, 'firstOnScene')
export const setFirstOnScenePNNV = makeActionCreator(
  SceneDescriptionConstants.SET_FIRST_ON_SCENE_PNNV,
  'firstOnScenePNNV'
)
export const setLevelCarePerProtocol = makeActionCreator(
  SceneDescriptionConstants.SET_LEVEL_CARE_PER_PROTOCOL,
  'levelCarePerProtocol'
)
export const setLevelCarePerProtocolPNNV = makeActionCreator(
  SceneDescriptionConstants.SET_LEVEL_CARE_PER_PROTOCOL_PNNV,
  'levelCarePerProtocolPNNV'
)
export const setPrOtherAgencies = makeActionCreator(SceneDescriptionConstants.SET_PR_OTHER_AGENCIES, 'prOtherAgencies')
export const setLawnum = makeActionCreator(SceneDescriptionConstants.SET_LAWNUM, 'lawnum')
export const setFirenum = makeActionCreator(SceneDescriptionConstants.SET_FIRENUM, 'firenum')
export const setPrDisaster = makeActionCreator(SceneDescriptionConstants.SET_PR_DISASTER, 'prDisaster')
export const setPrDispoInstructions = makeActionCreator(
  SceneDescriptionConstants.SET_PR_DISPO_INSTRUCTIONS,
  'prDispoInstructions'
)
export const setBelongings = makeActionCreator(SceneDescriptionConstants.SET_BELONGINGS, 'belongings')
export const setPrPtMovedVia = makeActionCreator(SceneDescriptionConstants.SET_PR_PT_MOVED_VIA, 'prPtMovedVia')
export const setPrPtPosition = makeActionCreator(SceneDescriptionConstants.SET_PR_PT_POSITION, 'prPtPosition')
export const setPrPtMovedFrom = makeActionCreator(SceneDescriptionConstants.SET_PR_PT_MOVED_FROM, 'prPtMovedFrom')
export const setPrTransportAssess = makeActionCreator(
  SceneDescriptionConstants.SET_PR_TRANSPORT_ASSESS,
  'prTransportAssess'
)
export const setStretcherPurposeDescr = makeActionCreator(
  SceneDescriptionConstants.SET_STRETCHER_PURPOSE_DESCR,
  'stretcherPurposeDescr'
)
export const addNewAgency = makeActionCreator(SceneDescriptionConstants.ADD_NEW_AGENCY)
export const removeAgency = makeActionCreator(SceneDescriptionConstants.REMOVE_AGENCY, 'key')
export const setOtherAgencies = makeActionCreator(SceneDescriptionConstants.SET_OTHER_AGENCIES, 'otherAgencies')
export const setOtherAgencyName = makeActionCreator(
  SceneDescriptionConstants.SET_OTHER_AGENCY_NAME,
  'agencyName',
  'key'
)
export const setOtherAgencyType = makeActionCreator(
  SceneDescriptionConstants.SET_OTHER_AGENCY_TYPE,
  'agencyType',
  'key'
)
export const setOtherAgencyNumber = makeActionCreator(
  SceneDescriptionConstants.SET_OTHER_AGENCY_NUMBER,
  'agencyNumber',
  'key'
)
export const setOtherAgencyFirstOnScene = makeActionCreator(
  SceneDescriptionConstants.SET_OTHER_AGENCY_FIRST_ON_SCENE,
  'firstOnScene',
  'key'
)
export const setOtherAgencyFirstOnScenePNNV = makeActionCreator(
  SceneDescriptionConstants.SET_OTHER_AGENCY_FIRST_ON_SCENE_PNNV,
  'firstOnScenePNNV',
  'key'
)
export const setTransferOfCare = makeActionCreator(SceneDescriptionConstants.SET_TRANSFER_OF_CARE, 'transferOfCare')
export const setTransferOfCarePNNV = makeActionCreator(
  SceneDescriptionConstants.SET_TRANSFER_OF_CARE_PNNV,
  'transferOfCarePNNV'
)
export const closeFirstOnSceneMessage = makeActionCreator(SceneDescriptionConstants.CLOSE_FIRST_ON_SCENE_MESSAGE)
export const updateFirstOnScene = makeActionCreator(SceneDescriptionConstants.UPDATE_FIRST_ON_SCENE)
export const cancelFirstOnSceneUpdate = makeActionCreator(SceneDescriptionConstants.CANCEL_FIRST_ON_SCENE_UPDATE)
export const setCadComments = makeActionCreator(SceneDescriptionConstants.SET_CAD_COMMENTS, 'cadComments')
export const deleteCadComments = makeActionCreator(SceneDescriptionConstants.DELETE_CAD_COMMENTS)
export const setSceneDescriptionState = makeActionCreator(
  SceneDescriptionConstants.SET_SCENE_DESCRIPTION_STATE,
  'sceneDescriptionState'
)
export const saveSceneDescriptionState = makeActionCreator(SceneDescriptionConstants.SAVE_SCENE_DESCRIPTION_STATE)
export const resetSceneDescriptionState = makeActionCreator(SceneDescriptionConstants.RESET_SCENE_DESCRIPTION_STATE)
